import { Board, Column } from './api';

export const COLUMN_EVENT_NAMES = {
  created: '.column.created',
  updated: '.column.updated',
  deleted: '.column.deleted',
} as const;

// Les events de colonne ne transportent jamais `cards`.
export interface ColumnPayload {
  id: number;
  board_id: number;
  title: string;
  position: number;
  created_at: string;
  updated_at: string;
}

export interface ColumnCreatedEvent {
  column: ColumnPayload;
  board_id: number;
}

export interface ColumnUpdatedEvent {
  column: ColumnPayload;
  board_id: number;
}

export interface ColumnDeletedEvent {
  column_id: number;
  board_id: number;
}

const sortByPosition = (columns: Column[]): Column[] => [...columns].sort((a, b) => a.position - b.position);

export const applyColumnCreated = (board: Board, event: ColumnCreatedEvent): Board => {
  if (event.board_id !== board.id) return board;
  if (board.columns.some((c) => c.id === event.column.id)) return board;

  const newColumn: Column = { ...event.column, cards: [] };
  return { ...board, columns: sortByPosition([...board.columns, newColumn]) };
};

// Ne met à jour que les propriétés propres à la colonne.
export const applyColumnUpdated = (board: Board, event: ColumnUpdatedEvent): Board => {
  if (event.board_id !== board.id) return board;
  if (!board.columns.some((c) => c.id === event.column.id)) return board;

  const columns = board.columns.map((c) =>
    c.id === event.column.id
      ? { ...c, title: event.column.title, position: event.column.position, updated_at: event.column.updated_at }
      : c
  );
  return { ...board, columns: sortByPosition(columns) };
};

export const applyColumnDeleted = (board: Board, event: ColumnDeletedEvent): Board => {
  if (event.board_id !== board.id) return board;
  return { ...board, columns: board.columns.filter((c) => c.id !== event.column_id) };
};
